import "./style.scss";

import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Spacer } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { ModalContent, WithModal } from "@amzn/stencil-react-components/modal";
import { Text } from "@amzn/stencil-react-components/text";
import { trackStructEvent } from "@snowplow/browser-tracker";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { VerificationStatus } from "@/apis/IdentityCheckHelper";
import { setLastFailedIdvType } from "@/components/IdentityCheck/helper/rivHelper";
import { AppContext } from "@/stores/appStore";
import { ActionType } from "@/stores/constants";
import { Day1EventAction, Day1EventCategory } from "@/types/snowplow-events";

import { useIVVAbort } from "./hooks/useIVVAbort";

const ConfirmModal = ({ close }: { close: () => unknown }) => {
  const intl = useIntl();
  const { dispatch } = useContext(AppContext);
  const { abortIVV } = useIVVAbort();

  const handleConfirm = () => {
    // When they click confirm, they need to be redirected to Manual IDV
    trackStructEvent({
      category: Day1EventCategory.AutomatedRivScreen,
      action: Day1EventAction.ClickConfirm,
    });

    dispatch({
      type: ActionType.SET_WIZARD_PATH,
      wizardPath: "ManualRIV",
    });

    dispatch({
      type: ActionType.SET_DOCS_VERIFICATION_STATUS,
      docsVerificationStatus: VerificationStatus.NOT_STARTED,
    });
    // Set this type as failed to prevent them from going back
    setLastFailedIdvType("automated");
    abortIVV();
    close();
  };
  const handleCancel = () => {
    trackStructEvent({
      category: Day1EventCategory.AutomatedRivScreen,
      action: Day1EventAction.ClickCancel,
    });
    close();
  };

  return (
    <ModalContent
      maxWidth="80vw"
      /* {{stencil-update}} ModalContent is going to be deprecated in 5.x, please use sub components ModalHeader, ModalBody and ModalFooter. */ /* {{stencil-update}} ModalContent is going to be deprecated in 5.x, please use sub components ModalHeader, ModalBody and ModalFooter. */ /* {{stencil-update}} ModalContent is going to be deprecated in 5.x, please use sub components ModalHeader, ModalBody and ModalFooter. */ /* {{stencil-update}} ModalContent is going to be deprecated in 5.x, please use sub components ModalHeader, ModalBody and ModalFooter. */ /* {{stencil-update}} ModalContent is going to be deprecated in 5.x, please use sub components ModalHeader, ModalBody and ModalFooter. */ /* {{stencil-update}} ModalContent is going to be deprecated in 5.x, please use sub components ModalHeader, ModalBody and ModalFooter. */ titleText={intl.formatMessage(
        {
          id: "identityCheck-ivv-scanAbortModalHeader",
        }
      )}
      buttons={[
        <Button
          key="cancel-btn"
          onClick={handleCancel}
          variant={ButtonVariant.Secondary}
        >
          {intl.formatMessage({ id: "identityCheck-ivv-scanAbortModalCancel" })}
        </Button>,
        <Button
          key="submit-btn"
          onClick={handleConfirm}
          variant={ButtonVariant.Primary}
        >
          {intl.formatMessage({
            id: "identityCheck-ivv-scanAbortModalConfirm",
          })}
        </Button>,
      ]}
    >
      <Text>
        <FormattedMessage
          id="identityCheck-ivv-scanAbortModalBody"
          values={{
            p: (text: string) => <p>{text}</p>,
          }}
        />
      </Text>
    </ModalContent>
  );
};

const IVVAbort = () => {
  const openModal = (open: () => unknown) => () => {
    trackStructEvent({
      category: Day1EventCategory.AutomatedRivScreen,
      action: Day1EventAction.ConfirmationModalDisplayed,
    });
    return open();
  };

  return (
    <Col dataTestId="ivvAbortText">
      <Text fontSize="T200" fontWeight="bold">
        <FormattedMessage id="identityCheck-ivv-scanAbortHeader" />
      </Text>
      <Spacer height="S200" />
      <Text>
        <WithModal shouldCloseOnClickOutside={true} renderModal={ConfirmModal}>
          {({ open }) => (
            <Text fontSize="T200">
              <FormattedMessage
                id="identityCheck-ivv-scanAbortBody"
                values={{
                  openModal: (text: string) => (
                    <Link className="abort-link" onClick={openModal(open)}>
                      {text}
                    </Link>
                  ),
                }}
              />
            </Text>
          )}
        </WithModal>
      </Text>
    </Col>
  );
};

export default IVVAbort;
